
import authReducer from "./auth/reducer";
import getbalanceresucer from "./Getbalance/reducer"
import getclaimdatareducer from "./Claimdata/reducer";
import gettaloadresucer from "./Taloadrequest/reducer";
import transactionhistoryreducer from "./Transactionhistory/reducer";
import getprofilereducer from "./Profilelogin/reducer";
import selectedRetailerReducer from "./SelectedRetailer/reducer"

import { combineReducers } from "redux";
import selectedDistributorReducer from "./Distributor/reducer";
import selectedretailerReqesterReducer from './RequesterId/reducer'
export const rootReducers = () =>
  combineReducers({
    authReducer,
    getbalanceresucer,
    getclaimdatareducer,
    gettaloadresucer,
    transactionhistoryreducer,
    getprofilereducer,
    selectedRetailerReducer,
    selectedDistributorReducer,
    selectedretailerReqesterReducer
  });
export default rootReducers;